import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import * as React from 'react';
var styles = require('./MailListHeaderSecondRow.scss');
var classNames = require('classnames/bind');
var MailListHeaderSecondRowTextContent = /** @class */ (function (_super) {
    tslib_1.__extends(MailListHeaderSecondRowTextContent, _super);
    function MailListHeaderSecondRowTextContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MailListHeaderSecondRowTextContent.prototype.render = function () {
        return (React.createElement("div", { className: classNames(styles.customTextContainer, this.props.containerCssClass), role: "heading", "aria-level": 2 },
            React.createElement("span", { className: styles.customHeaderText }, this.props.text)));
    };
    MailListHeaderSecondRowTextContent = tslib_1.__decorate([
        observer
    ], MailListHeaderSecondRowTextContent);
    return MailListHeaderSecondRowTextContent;
}(React.Component));
export default MailListHeaderSecondRowTextContent;
//# sourceMappingURL=MailListHeaderSecondRowTextContent.js.map